import type { MealTiersMiniEntity } from "@/features/mealTiers/domain/entities/MealTiersMiniEntity"

export class UpdateCompanyUserEntity {
  mealTier?: MealTiersMiniEntity | null
  maxItemPerMeal?: number | null
}

